import { InjectionToken } from '@angular/core';

// FIXME: add all `fileReplacements` under `configuration` for the environment library

export * from './environment';
export * from './models';
export const ENVIRONMENT_CONFIG = new InjectionToken('Environment config');
